import type { ReactNode, SVGProps } from 'react'

/**
 * Drie verbonden punten: de knop Delen in de werkbalk van het formulier (R-64, besluit van 2 november
 * 2026). Dezelfde lijnvorm en maat als Bronnen, Opmerkingen en Geschiedenis ernaast (`RightPanel.tsx`).
 */
export function ShareIcon(props: SVGProps<SVGSVGElement>): ReactNode {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      style={{ width: 'var(--nwo-space-sp-5)', height: 'var(--nwo-space-sp-5)', flexShrink: 0 }}
      focusable="false"
      {...props}
    >
      <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
      <path d="m8.6 13.5 6.8 4" /><path d="m15.4 6.5-6.8 4" />
    </svg>
  )
}
